import { render, staticRenderFns } from "./Mailbox.vue?vue&type=template&id=89e27ddc&scoped=true&"
import script from "./Mailbox.vue?vue&type=script&lang=js&"
export * from "./Mailbox.vue?vue&type=script&lang=js&"
import style0 from "./Mailbox.vue?vue&type=style&index=0&id=89e27ddc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e27ddc",
  null
  
)

export default component.exports